<script>
import SnackbarContainer from './components/SnackBar/Container.vue';
import { updateDocumentTitle } from 'shared/helpers/pageTitle';

export default {
  components: { SnackbarContainer },
  data() {
    return { theme: 'light' };
  },
  mounted() {
    this.setColorTheme();
    this.listenToThemeChanges();
    this.setLocale(this.detectLocale());
  },
  methods: {
    detectLocale() {
      const enabledLanguages = (
        window.chatwootConfig.enabledLanguages || []
      ).map(l => l.iso_639_1_code);
      const browserLocales = navigator.languages || [navigator.language];

      for (const browserLocale of browserLocales) {
        // Try exact match first (e.g. "pt-BR" -> "pt_BR")
        const normalized = browserLocale.replace('-', '_');
        if (enabledLanguages.includes(normalized)) return normalized;

        // Try language-only match (e.g. "pt-BR" -> "pt", "es-AR" -> "es")
        const lang = browserLocale.split('-')[0];
        const match = enabledLanguages.find(l => l.split('_')[0] === lang);
        if (match) return match;
      }

      return window.chatwootConfig.selectedLocale;
    },
    setColorTheme() {
      if (window.matchMedia('(prefers-color-scheme: dark)').matches) {
        this.theme = 'dark';
      } else {
        this.theme = 'light ';
      }
    },
    listenToThemeChanges() {
      const mql = window.matchMedia('(prefers-color-scheme: dark)');

      mql.onchange = e => {
        if (e.matches) {
          this.theme = 'dark';
        } else {
          this.theme = 'light';
        }
      };
    },
    setLocale(locale) {
      this.$root.$i18n.locale = locale;
      // detectLocale() only runs on mount, by which point the router's
      // afterEach has already titled the first route using the default `en`
      // locale. Re-title so a pt_BR/es visitor doesn't sit on an English tab
      // until their next navigation.
      updateDocumentTitle(this.$route, {
        i18n: this.$root.$i18n,
        store: this.$store,
      });
    },
  },
};
</script>

<template>
  <div class="h-full w-full antialiased" :class="theme">
    <router-view />
    <SnackbarContainer />
  </div>
</template>

<style lang="scss">
@tailwind base;
@tailwind components;
@tailwind utilities;

@import 'shared/assets/fonts/plus-jakarta';
@import 'shared/assets/stylesheets/colors';
@import 'shared/assets/stylesheets/spacing';
@import 'shared/assets/stylesheets/font-size';
@import 'shared/assets/stylesheets/border-radius';

html,
body {
  font-family:
    'Inter',
    'PlusJakarta',
    -apple-system,
    BlinkMacSystemFont,
    'Segoe UI',
    Roboto,
    Oxygen-Sans,
    Ubuntu,
    Cantarell,
    'Helvetica Neue',
    sans-serif;
  @apply h-full w-full;

  input,
  select {
    outline: none;
  }
}

.text-link {
  @apply text-woot-500 font-medium hover:text-woot-600;
}

.tooltip {
  @apply bg-slate-900 text-white py-1 px-2 z-40 text-xs rounded-md dark:bg-slate-300 dark:text-slate-900;
}
</style>
